import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import ModuleForm from '../../ApplicationModules/components/ModuleForm';

const PreviewModal = ({ isOpen = false, onClose, formId }) => {
	const modalRef = useRef();
	useEffect(() => {
		if (isOpen) {
			modalRef.current.showModal();
		}
	}, [isOpen]);

	return (
		<dialog id="preview-dialog" className="modal" ref={modalRef}>
			<div className="modal-box">
				<h3>Preview Application Module</h3>
				<div className="py-4">
					<ModuleForm readOnly formId={formId} />
				</div>
				<div className="modal-action">
					<form method="dialog">
						<button className="ml-4 btn btn-primary" onClick={onClose}>
							Close
						</button>
					</form>
				</div>
			</div>
		</dialog>
	);
};

PreviewModal.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	formId: PropTypes.number,
};

export default PreviewModal;
